import { styled } from '@mui/material';

export const StyledImage = styled('img')(() => ({
  width: '100%',
  borderRadius: '16px',
  objectFit: 'cover',
  aspectRatio: '555/395',
}));
